import AIChatProvider from '@/app/components/features/aiChat/AIChatContext';
import useEntryChat from '@/app/components/features/aiChat/hooks/useEntryChat';
import { Sidechat } from '@/app/components/shared/Sidechat';
import { getContractDetailsQuery } from '@/app/hooks/queries/useContracts';
import { Main } from '@/app/ui/components/main';
import { ChatType, EvaluationTypeLabelsEnum } from '@/app/utils/constants';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authed/project/$projectId/_layout/(evaluation)/contracts/$contractId/contract-management/$supplementId/_layout/(supplement)/_layout',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { contractId, supplementId } = Route.useParams();
  const { data: evaluation } = useSuspenseQuery(getContractDetailsQuery(contractId));

  const stream = useEntryChat({
    id: contractId,
    namespace: ChatType.SUPPLEMENT,
    supplementId,
  });

  return (
    <AIChatProvider
      chatType={ChatType.SUPPLEMENT}
      sourceStream={stream}
      chatInitialOpen={false}
      evaluationName={evaluation.name}
      evaluationType={EvaluationTypeLabelsEnum.CONTRACT}
      evaluationId={contractId}
    >
      <Main>
        <Outlet />
      </Main>
      <Sidechat />
    </AIChatProvider>
  );
}
